<template lang='pug'>
  .nav-container#js-nav-container
    template(v-if='isMobile')
      dropdown-nav(:accountTitle='accountTitle',
                   :accountLinks='accountLinks',
                   :beautyPassTitle='beautyPassTitle',
                   :beautyPassLinks='beautyPassLinks')
    template(v-else)
      sidebar-nav(:accountTitle='accountTitle',
                  :accountLinks='accountLinks',
                  :beautyPassTitle='beautyPassTitle',
                  :beautyPassLinks='beautyPassLinks')
</template>

<script>
import { mapState } from 'vuex'
import SidebarNav from './nav/sidebar.vue'
import DropdownNav from './nav/dropdown.vue'

export default {
  components: {
    DropdownNav,
    SidebarNav
  },

  data () {
    return {
      accountTitle: this.$t('account.dashboard.title'),
      beautyPassTitle: this.$t('account.sephoraBeautyPass.title'),
      beautyPassLinks: [
        { label: this.$t('account.beautyPassBenefits.title'), path: '/beauty-pass' },
        { label: this.$t('account.rewardsBoutique.title'), path: '/rewards-boutique' },
        { label: this.$t('account.pointLogs.pointsSummary'), path: '/account/point_logs', routerLinked: true }
      ]
    }
  },

  computed: {
    ...mapState({
      beautyProfileEnabled: () => vueSupport?.featureFlags?.enableBeautyProfile
    }),

    isMobile: () => vueSupport.isMobile,

    accountLinks () {
      return [
        { label: this.$t('account.dashboard.dashboard'), path: '/account/dashboard' },
        { label: this.$t('account.orders.title'), path: '/account/orders' },
        { label: this.$t('account.getItAgain.title'), path: '/account/get-it-again' },
        { label: this.$t('account.reviews.title'), path: '/account/reviews', routerLinked: true },
        { label: this.$t('account.wishlist.title'), path: '/wishlist', routerLinked: true },
        { label: this.$t('account.waitlist.title'), path: '/waitlists' },
        {
          label: this.$t('account.beautyProfile.title'),
          path: this.beautyProfileEnabled ? '/account/beauty-profile' : '/account/insider_profile'
        },
        { label: this.$t('account.details.title'), path: '/account' }
      ]
    }
  }
}
</script>
